import React from "react";

import { colors } from "utils/styles";
export default function MegaNavContainer(props) {
	return (
		<div className={`megaNavContainer ` + props.className} style={{}}>
			{props.children}

			<style jsx>{`
				.megaNavContainer {
					position: absolute;
					top: 1.2em;
					left: ${props.left || "-10em"};
					width: auto;
					background: ${colors.white};
					box-shadow: -2px 10px 6px rgba(0, 0, 0, 0.16);
					z-index: 1000;
				}
			`}</style>
		</div>
	);
}
